function initStartingAtScript() {
  // EXIT EARLY: Do not run on product pages
  if (window.location.href.includes('/products/')) {
    // console.log("Product page detected. Skipping 'Starting at' script.");
    return; 
  }

  // console.log("DOM is ready. Running Tag-based polling logic..."); 

  async function applyStartingAt() {
    const boldShopify = window.BOLD?.common?.Shopify;
    const boldProducts = boldShopify?.products 
      ? Object.values(boldShopify.products) 
      : [];
    const boldProductIds = boldProducts.map(p => String(p.id));

    const allBlocks = Array.from(document.querySelectorAll('[data-product-id]'));
        
    const readyBlocks = allBlocks.filter(block => {
      const link = block.querySelector('a[href*="/products/"]');
      const price = block.querySelector('.price__current, .nosto-product-price, .price, .money, .price-item');
      return link !== null && price !== null;
    });

    if (readyBlocks.length === 0) return;

    const fetchTasks = readyBlocks.map(async (block) => {
      const productId = String(block.getAttribute('data-product-id'));
      const linkElement = block.querySelector('a[href*="/products/"]');
      const priceElement = block.querySelector('.price__current, .nosto-product-price, .price, .money, .price-item');

      // Skip if already processed
      if (priceElement.classList.contains('starting-at-added') || 
          priceElement.classList.contains('bold-tag-checked') ||
          priceElement.textContent.toLowerCase().includes('starting at')) {
        return;
      }

      let hasBoldTag = false;
      const cacheKey = `bold_tag_v2_${productId}`; 

      // -------------------------------------------------------------------
      // CACHE CHECK: Sabse pehle cache dekho (sabse fast)
      // -------------------------------------------------------------------
      const cachedResult = sessionStorage.getItem(cacheKey);
      if (cachedResult === 'true') {
        hasBoldTag = true;
      } else if (cachedResult === 'false') {
        priceElement.classList.add('bold-tag-checked');
        return;
      } else {
        // -------------------------------------------------------------------
        // PATH A: Product BOLD object mein hai
        // BOLD object ka tags unreliable hai - Shopify API se verify karo
        // Cache hoga toh sirf ek baar fetch hoga
        // -------------------------------------------------------------------
        if (boldProductIds.includes(productId)) {
          try {
            const urlObj = new URL(linkElement.href, window.location.origin);
            const jsonUrl = `${urlObj.origin}${urlObj.pathname}.js`;
            
            const response = await fetch(jsonUrl);
            if (!response.ok) return;
            
            const productData = await response.json();
            hasBoldTag = productData.tags && 
              productData.tags.some(tag => tag.trim().toLowerCase() === 'bold');

            console.log(`PATH A (API) - Product ${productId}, hasBoldTag: ${hasBoldTag}`);
            sessionStorage.setItem(cacheKey, hasBoldTag ? 'true' : 'false');
          } catch (error) {
            // Silent fail
            return;
          }
        } else {
          // -------------------------------------------------------------------
          // PATH C: BOLD object mein nahi - Shopify API se fetch karo
          // -------------------------------------------------------------------
          try {
            const urlObj = new URL(linkElement.href, window.location.origin);
            const jsonUrl = `${urlObj.origin}${urlObj.pathname}.js`;
            
            const response = await fetch(jsonUrl);
            if (!response.ok) return; 
            
            const productData = await response.json();
            hasBoldTag = productData.tags && 
              productData.tags.some(tag => tag.trim().toLowerCase() === 'bold');

            console.log(`PATH C (API) - Product ${productId}, hasBoldTag: ${hasBoldTag}`);
            sessionStorage.setItem(cacheKey, hasBoldTag ? 'true' : 'false'); 
          } catch (error) {
            // Silent fail
            return; 
          }
        }
      }

      // -------------------------------------------------------------------
      // APPLY TEXT (Re-querying DOM to beat Boost Commerce rendering)
      // -------------------------------------------------------------------
      const currentBlock = document.querySelector(`[data-product-id="${productId}"]`);
      if (currentBlock) {
        const currentPriceElement = currentBlock.querySelector('.price__current, .nosto-product-price, .price, .money, .price-item');
        
        if (currentPriceElement && 
            !currentPriceElement.classList.contains('starting-at-added') && 
            !currentPriceElement.textContent.toLowerCase().includes('starting at')) {
          
          if (hasBoldTag) {
            // console.log(`✅ Adding 'Starting at' to ${productId}`); 
            currentPriceElement.textContent = `Starting at ${currentPriceElement.textContent.trim()}`;
            currentPriceElement.classList.add('starting-at-added'); 
          } else {
            currentPriceElement.classList.add('bold-tag-checked');
          }
        }
      }
    });

    await Promise.all(fetchTasks);
  }

  // Polling every 800ms to catch fully rendered elements safely
  setInterval(applyStartingAt, 800); 
}

// Ensure DOM is ready before injecting logic
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initStartingAtScript);
} else {
  initStartingAtScript();
}